import styled from "styled-components";

export const EnvironmentBanner = styled.div`
  align-items: center;
  column-gap: 4px;
  display: flex;
  flex-flow: row nowrap;
  height: 50px;
  justify-content: center;
  padding: 4px;
  width: 100%;
`;

export const DevelopmentBanner = styled(EnvironmentBanner)`
  background-color: var(--color-surface);
  border: 2px solid var(--color-surface-border);
  color: var(--color-on-surface);
`;

export const TestBranchBanner = styled(EnvironmentBanner)`
  background-color: var(--color-info-background);
  border: 2px solid var(--color-info-accent);
  color: var(--color-on-surface);
`;
